// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n7-1";
export var stateContainer = "_n7-0";